module.exports = __webpack_public_path__ + "img/sn-inst.f53bf7bf.svg";